import { Divider, LayoutVerticalSpacer } from '@madpaws/design-system';
import { useFormikContext } from 'formik';

import { PETS_KIDS_AT_HOME_OPTIONS, SITTERS_HOME_OPTIONS } from '~/common/constants/search';

import { CheckboxGroupField } from '../../ui/CheckboxGroupField/CheckboxGroupField';
import { isSitterHomeBasedServiceSelected } from '../../utils';

import type { ReactElement } from 'react';
import type { SearchFilters } from '~/common/types/search';

const SitterHomeOptionsFields = (): ReactElement => {
  const { values } = useFormikContext<SearchFilters>();
  const isSitterHomeBasedService = isSitterHomeBasedServiceSelected(values.service.type);

  if (!isSitterHomeBasedService) {
    return <></>;
  }

  return (
    <LayoutVerticalSpacer space="large1x">
      <CheckboxGroupField
        legend="Sitter’s home"
        name="advancedFilters.sittersHome"
        options={SITTERS_HOME_OPTIONS}
        variant="buttonMultiselect"
      />
      <Divider />
      <CheckboxGroupField
        legend="Pets/kids at Sitter’s home"
        name="advancedFilters.sittersPetsKids"
        options={PETS_KIDS_AT_HOME_OPTIONS}
        variant="buttonMultiselect"
      />
      <Divider />
    </LayoutVerticalSpacer>
  );
};

export { SitterHomeOptionsFields };
